import { TypeIdentification } from "../store/medicalAppointment/types";
export const validateIdentificationEC = (value: string, typeIdentificationAnother: string): boolean => {
    let typeIdentificationRegister = typeIdentificationAnother;
    if (typeof (value) === 'string' && value.length === 10 &&
        typeIdentificationRegister === TypeIdentification.IdentificationCard) {
    let digits = value.split('').map(Number);
    let provincialCode = digits[0] * 10 + digits[1];

    if (provincialCode >= 1 && (provincialCode <= 24 || provincialCode === 30)) {
        let checkerDigit = digits.pop();
        let calculatedDigit = digits.reduce(
            (previousValue, currentValue, index) => {
                let isNine = (currentValue === 9) ? 1 : 0;
                return previousValue - ((currentValue * (2 - index % 2)) % 9) - isNine * 9;
            }, 1000) % 10;
        if (calculatedDigit !== checkerDigit) {
            return false;
        }
    } else {
        return false;
        }
    }
    return true;
};